import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import UserProfile from "ui/organizms/Users";

const User = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Users'
    >
        <UserProfile />
    </Screen>
);

export default memo(User);
